import { render, staticRenderFns } from "./modalHistoricoBuscaForca.vue?vue&type=template&id=1399b4f4"
import script from "./modalHistoricoBuscaForca.vue?vue&type=script&lang=js"
export * from "./modalHistoricoBuscaForca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports